// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IReducedPlanYearDto } from './IReducedPlanYearDto';
import {
    IReducedPlanYearDtoFromJSON,
    IReducedPlanYearDtoFromJSONTyped,
    IReducedPlanYearDtoToJSON,
    IReducedPlanYearDtoToJSONTyped,
} from './IReducedPlanYearDto';
import type { ICoveragePeriodDto } from './ICoveragePeriodDto';
import {
    ICoveragePeriodDtoFromJSON,
    ICoveragePeriodDtoFromJSONTyped,
    ICoveragePeriodDtoToJSON,
    ICoveragePeriodDtoToJSONTyped,
} from './ICoveragePeriodDto';
import type { IServiceLiteWithCategoryTypeDto } from './IServiceLiteWithCategoryTypeDto';
import {
    IServiceLiteWithCategoryTypeDtoFromJSON,
    IServiceLiteWithCategoryTypeDtoFromJSONTyped,
    IServiceLiteWithCategoryTypeDtoToJSON,
    IServiceLiteWithCategoryTypeDtoToJSONTyped,
} from './IServiceLiteWithCategoryTypeDto';
import type { ICategorySpendLimitDto } from './ICategorySpendLimitDto';
import {
    ICategorySpendLimitDtoFromJSON,
    ICategorySpendLimitDtoFromJSONTyped,
    ICategorySpendLimitDtoToJSON,
    ICategorySpendLimitDtoToJSONTyped,
} from './ICategorySpendLimitDto';
import type { IPersonSpendLimitDto } from './IPersonSpendLimitDto';
import {
    IPersonSpendLimitDtoFromJSON,
    IPersonSpendLimitDtoFromJSONTyped,
    IPersonSpendLimitDtoToJSON,
    IPersonSpendLimitDtoToJSONTyped,
} from './IPersonSpendLimitDto';

/**
 * 
 * @export
 * @interface IAccountOrderDto
 */
export interface IAccountOrderDto {
    /**
     * 
     * @type {number}
     * @memberof IAccountOrderDto
     */
    account_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountOrderDto
     */
    policy_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountOrderDto
     */
    plan_id?: number;
    /**
     * 
     * @type {IReducedPlanYearDto}
     * @memberof IAccountOrderDto
     */
    plan_year?: IReducedPlanYearDto;
    /**
     * 
     * @type {string}
     * @memberof IAccountOrderDto
     */
    plan_status?: IAccountOrderDtoPlanStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IAccountOrderDto
     */
    plan_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IAccountOrderDto
     */
    order?: number;
    /**
     * 
     * @type {string}
     * @memberof IAccountOrderDto
     */
    omnibus_type?: IAccountOrderDtoOmnibusTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IAccountOrderDto
     */
    account_type?: IAccountOrderDtoAccountTypeEnum;
    /**
     * 
     * @type {Array<ICoveragePeriodDto>}
     * @memberof IAccountOrderDto
     */
    coverage_periods?: Array<ICoveragePeriodDto>;
    /**
     * 
     * @type {Date}
     * @memberof IAccountOrderDto
     */
    submit_claims_date_end?: Date;
    /**
     * 
     * @type {number}
     * @memberof IAccountOrderDto
     */
    available_balance?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IAccountOrderDto
     * @deprecated
     */
    is_replenished?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IAccountOrderDto
     */
    is_replenished_plan?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IAccountOrderDto
     */
    funding_method_type?: IAccountOrderDtoFundingMethodTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IAccountOrderDto
     */
    proof_of_expenses_type?: IAccountOrderDtoProofOfExpensesTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IAccountOrderDto
     */
    proof_of_expenses_card_type?: IAccountOrderDtoProofOfExpensesCardTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IAccountOrderDto
     */
    ai_adjudication_type?: IAccountOrderDtoAiAdjudicationTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IAccountOrderDto
     */
    commuter_limit_amount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IAccountOrderDto
     */
    is_plan_level_funding?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IAccountOrderDto
     */
    rollover_account_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountOrderDto
     */
    rollover_limit_amount?: number;
    /**
     * 
     * @type {Array<ICoveragePeriodDto>}
     * @memberof IAccountOrderDto
     */
    prior_rollover_policy_coverage_periods?: Array<ICoveragePeriodDto>;
    /**
     * 
     * @type {Date}
     * @memberof IAccountOrderDto
     */
    prior_rollover_policy_submit_claims_date_end?: Date;
    /**
     * 
     * @type {number}
     * @memberof IAccountOrderDto
     */
    prior_rollover_limit?: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountOrderDto
     */
    max_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountOrderDto
     */
    percentage?: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountOrderDto
     */
    processing_tier_id?: number;
    /**
     * 
     * @type {Array<IServiceLiteWithCategoryTypeDto>}
     * @memberof IAccountOrderDto
     */
    services?: Array<IServiceLiteWithCategoryTypeDto>;
    /**
     * 
     * @type {boolean}
     * @memberof IAccountOrderDto
     */
    is_forfeited?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IAccountOrderDto
     */
    account_status?: IAccountOrderDtoAccountStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof IAccountOrderDto
     */
    election_limit_amount?: number;
    /**
     * 
     * @type {Array<IPersonSpendLimitDto>}
     * @memberof IAccountOrderDto
     */
    person_spend_limits?: Array<IPersonSpendLimitDto>;
    /**
     * 
     * @type {Array<ICategorySpendLimitDto>}
     * @memberof IAccountOrderDto
     */
    category_spend_limits?: Array<ICategorySpendLimitDto>;
}

/**
* @export
* @enum {string}
*/
export enum IAccountOrderDtoPlanStatusEnum {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    READY_FOR_SETUP = 'READY_FOR_SETUP',
    DELETED = 'DELETED',
    PENDING_ACTIVE = 'PENDING_ACTIVE',
    UNDER_UPDATE = 'UNDER_UPDATE',
    TERMINATION_IN_PROGRESS = 'TERMINATION_IN_PROGRESS',
    PENDING_TERMINATION = 'PENDING_TERMINATION',
    TERMINATED = 'TERMINATED',
    PENDING_REACTIVATION = 'PENDING_REACTIVATION'
}
/**
* @export
* @enum {string}
*/
export enum IAccountOrderDtoOmnibusTypeEnum {
    HSA = 'HSA',
    NOTIONAL = 'NOTIONAL'
}
/**
* @export
* @enum {string}
*/
export enum IAccountOrderDtoAccountTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}
/**
* @export
* @enum {string}
*/
export enum IAccountOrderDtoFundingMethodTypeEnum {
    STANDARD_NOTIONAL = 'STANDARD_NOTIONAL',
    PREFUND_SPENDDOWN = 'PREFUND_SPENDDOWN',
    PREFUND_AND_CONTRIBUTION = 'PREFUND_AND_CONTRIBUTION',
    CONTRIBUTION_ONLY = 'CONTRIBUTION_ONLY'
}
/**
* @export
* @enum {string}
*/
export enum IAccountOrderDtoProofOfExpensesTypeEnum {
    RECEIPT_REQUIRED = 'RECEIPT_REQUIRED',
    NO_RECEIPT_REQUIRED = 'NO_RECEIPT_REQUIRED'
}
/**
* @export
* @enum {string}
*/
export enum IAccountOrderDtoProofOfExpensesCardTypeEnum {
    RECEIPT_REQUIRED = 'RECEIPT_REQUIRED',
    NO_RECEIPT_REQUIRED = 'NO_RECEIPT_REQUIRED'
}
/**
* @export
* @enum {string}
*/
export enum IAccountOrderDtoAiAdjudicationTypeEnum {
    ENABLED = 'ENABLED',
    DISABLED = 'DISABLED',
    ORG_SETTINGS = 'ORG_SETTINGS'
}
/**
* @export
* @enum {string}
*/
export enum IAccountOrderDtoAccountStatusEnum {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
    PENDING_CLOSED = 'PENDING_CLOSED',
    FROZEN = 'FROZEN',
    PENDING = 'PENDING'
}


/**
 * Check if a given object implements the IAccountOrderDto interface.
 */
export function instanceOfIAccountOrderDto(value: object): value is IAccountOrderDto {
    return true;
}

export function IAccountOrderDtoFromJSON(json: any): IAccountOrderDto {
    return IAccountOrderDtoFromJSONTyped(json, false);
}

export function IAccountOrderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAccountOrderDto {
    if (json == null) {
        return json;
    }
    return {
        
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'policy_id': json['policy_id'] == null ? undefined : json['policy_id'],
        'plan_id': json['plan_id'] == null ? undefined : json['plan_id'],
        'plan_year': json['plan_year'] == null ? undefined : IReducedPlanYearDtoFromJSON(json['plan_year']),
        'plan_status': json['plan_status'] == null ? undefined : json['plan_status'],
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
        'order': json['order'] == null ? undefined : json['order'],
        'omnibus_type': json['omnibus_type'] == null ? undefined : json['omnibus_type'],
        'account_type': json['account_type'] == null ? undefined : json['account_type'],
        'coverage_periods': json['coverage_periods'] == null ? undefined : ((json['coverage_periods'] as Array<any>).map(ICoveragePeriodDtoFromJSON)),
        'submit_claims_date_end': json['submit_claims_date_end'] == null ? undefined : (new Date(json['submit_claims_date_end'])),
        'available_balance': json['available_balance'] == null ? undefined : json['available_balance'],
        'is_replenished': json['is_replenished'] == null ? undefined : json['is_replenished'],
        'is_replenished_plan': json['is_replenished_plan'] == null ? undefined : json['is_replenished_plan'],
        'funding_method_type': json['funding_method_type'] == null ? undefined : json['funding_method_type'],
        'proof_of_expenses_type': json['proof_of_expenses_type'] == null ? undefined : json['proof_of_expenses_type'],
        'proof_of_expenses_card_type': json['proof_of_expenses_card_type'] == null ? undefined : json['proof_of_expenses_card_type'],
        'ai_adjudication_type': json['ai_adjudication_type'] == null ? undefined : json['ai_adjudication_type'],
        'commuter_limit_amount': json['commuter_limit_amount'] == null ? undefined : json['commuter_limit_amount'],
        'is_plan_level_funding': json['is_plan_level_funding'] == null ? undefined : json['is_plan_level_funding'],
        'rollover_account_id': json['rollover_account_id'] == null ? undefined : json['rollover_account_id'],
        'rollover_limit_amount': json['rollover_limit_amount'] == null ? undefined : json['rollover_limit_amount'],
        'prior_rollover_policy_coverage_periods': json['prior_rollover_policy_coverage_periods'] == null ? undefined : ((json['prior_rollover_policy_coverage_periods'] as Array<any>).map(ICoveragePeriodDtoFromJSON)),
        'prior_rollover_policy_submit_claims_date_end': json['prior_rollover_policy_submit_claims_date_end'] == null ? undefined : (new Date(json['prior_rollover_policy_submit_claims_date_end'])),
        'prior_rollover_limit': json['prior_rollover_limit'] == null ? undefined : json['prior_rollover_limit'],
        'max_amount': json['max_amount'] == null ? undefined : json['max_amount'],
        'percentage': json['percentage'] == null ? undefined : json['percentage'],
        'processing_tier_id': json['processing_tier_id'] == null ? undefined : json['processing_tier_id'],
        'services': json['services'] == null ? undefined : ((json['services'] as Array<any>).map(IServiceLiteWithCategoryTypeDtoFromJSON)),
        'is_forfeited': json['is_forfeited'] == null ? undefined : json['is_forfeited'],
        'account_status': json['account_status'] == null ? undefined : json['account_status'],
        'election_limit_amount': json['election_limit_amount'] == null ? undefined : json['election_limit_amount'],
        'person_spend_limits': json['person_spend_limits'] == null ? undefined : ((json['person_spend_limits'] as Array<any>).map(IPersonSpendLimitDtoFromJSON)),
        'category_spend_limits': json['category_spend_limits'] == null ? undefined : ((json['category_spend_limits'] as Array<any>).map(ICategorySpendLimitDtoFromJSON)),
    };
}

export function IAccountOrderDtoToJSON(json: any): IAccountOrderDto {
    return IAccountOrderDtoToJSONTyped(json, false);
}

export function IAccountOrderDtoToJSONTyped(value?: IAccountOrderDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_id': value['account_id'],
        'policy_id': value['policy_id'],
        'plan_id': value['plan_id'],
        'plan_year': IReducedPlanYearDtoToJSON(value['plan_year']),
        'plan_status': value['plan_status'],
        'plan_name': value['plan_name'],
        'order': value['order'],
        'omnibus_type': value['omnibus_type'],
        'account_type': value['account_type'],
        'coverage_periods': value['coverage_periods'] == null ? undefined : ((value['coverage_periods'] as Array<any>).map(ICoveragePeriodDtoToJSON)),
        'submit_claims_date_end': value['submit_claims_date_end'] == null ? undefined : ((value['submit_claims_date_end']).toISOString().substring(0,10)),
        'available_balance': value['available_balance'],
        'is_replenished': value['is_replenished'],
        'is_replenished_plan': value['is_replenished_plan'],
        'funding_method_type': value['funding_method_type'],
        'proof_of_expenses_type': value['proof_of_expenses_type'],
        'proof_of_expenses_card_type': value['proof_of_expenses_card_type'],
        'ai_adjudication_type': value['ai_adjudication_type'],
        'commuter_limit_amount': value['commuter_limit_amount'],
        'is_plan_level_funding': value['is_plan_level_funding'],
        'rollover_account_id': value['rollover_account_id'],
        'rollover_limit_amount': value['rollover_limit_amount'],
        'prior_rollover_policy_coverage_periods': value['prior_rollover_policy_coverage_periods'] == null ? undefined : ((value['prior_rollover_policy_coverage_periods'] as Array<any>).map(ICoveragePeriodDtoToJSON)),
        'prior_rollover_policy_submit_claims_date_end': value['prior_rollover_policy_submit_claims_date_end'] == null ? undefined : ((value['prior_rollover_policy_submit_claims_date_end']).toISOString().substring(0,10)),
        'prior_rollover_limit': value['prior_rollover_limit'],
        'max_amount': value['max_amount'],
        'percentage': value['percentage'],
        'processing_tier_id': value['processing_tier_id'],
        'services': value['services'] == null ? undefined : ((value['services'] as Array<any>).map(IServiceLiteWithCategoryTypeDtoToJSON)),
        'is_forfeited': value['is_forfeited'],
        'account_status': value['account_status'],
        'election_limit_amount': value['election_limit_amount'],
        'person_spend_limits': value['person_spend_limits'] == null ? undefined : ((value['person_spend_limits'] as Array<any>).map(IPersonSpendLimitDtoToJSON)),
        'category_spend_limits': value['category_spend_limits'] == null ? undefined : ((value['category_spend_limits'] as Array<any>).map(ICategorySpendLimitDtoToJSON)),
    };
}

